import { useContext } from 'react';
import connectionContext from './connectionContext';

export default function useConnectionState() {
    const context = useContext(connectionContext);

    if (!Object.keys(context).length) {
        throw new Error('ConnectionContext must be used within its provider');
    }

    return context;
}
